/**
 * Array of keypress key names
 * @module keys
 * */

export default [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "0",
  ".",
  "=",
  "/",
  "Escape",
  " ",
  "%",
  "*",
  "-",
  "+",
  "Backspace",
];
